import Config from '@config';
import {
  FiltersGrid,
  Pagination,
  ReferenceBook,
  infiniteQueryOptions,
  normalizeInfiniteQueryData,
} from '@gasbi/shared/index';
import { createApi } from '@reduxjs/toolkit/query/react';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const supplyTariffTypesApi = createApi({
  reducerPath: 'supplyTariffTypesApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/supply-tariff-types`,
  }),
  tagTypes: ['SupplyTariffType'],
  endpoints: builder => ({
    getSupplyTariffTypes: builder.query<ReferenceBook[], void>({
      query: () => ({ url: '/' }),
      providesTags: () => ['SupplyTariffType'],
    }),
    getSupplyTariffTypesI: builder.infiniteQuery<
      ReferenceBook[],
      FiltersGrid,
      Pagination
    >({
      infiniteQueryOptions,
      query: ({ queryArg, pageParam }) => ({
        url: '/query',
        method: 'GET',
        params: { ...queryArg, ...pageParam },
      }),
      providesTags: () => ['SupplyTariffType'],
    }),
  }),
});

export const { useGetSupplyTariffTypesQuery } = supplyTariffTypesApi;

export const useGetSupplyTariffTypesInfiniteQuery = normalizeInfiniteQueryData(
  supplyTariffTypesApi.useGetSupplyTariffTypesIInfiniteQuery,
);
